import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { upiTransactionTypes } from "../../../types/paymentType";

const initialState = {
  order_id: "",
  utr: "",
  amount: "",
  vpa_id: "",
  txn_time: "",
};

const upiTransaction = createSlice({
  name: "upiTransaction",
  initialState: initialState,
  reducers: {
    setUpiTransactionData: (
      state,
      action: PayloadAction<upiTransactionTypes>
    ) => {
      state = { ...state, ...action.payload };
    },
    resetUpiTransactionData: (state) => {
      state = initialState;
    },
  },
});

export const { resetUpiTransactionData, setUpiTransactionData } =
  upiTransaction.actions;

export default upiTransaction.reducer;
